import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {MenuItem,Icon} from "@/components";
import {Menu} from "antd";
import "./index.less";
import {Picker} from "antd-mobile";
import {useStores} from "@/store";
/**All */
const All = ({menus,tap}) => {
    let temp = [];
    let openKeys = []
    for (let key in menus) {
        let menu = menus[key];
        openKeys.push(key)
        temp.push({
            "key": key,
            "value": menu
        })
    }
    menus = temp;
    if (!menus.length) return null;
    const [state, setState] = useState({
        current: menus[0].key,
        openKeys: menus[0].key
    });
    const [allmenus, setAllmenus] = useState();// Popular
    const {restaurantStore} = useStores();
    const [selectTimeAndDiscountData, setSelectTimeAndDiscountData] = useState([]);//
    const [saveNormalIconVisible, setSaveNormalIconVisible] = useState(false);// saveNormalIconVisible
    const [saveIconVisible, setSaveIconVisible] = useState(false);// saveIconVisible
    const [canceIconVisible, setCancelIconVisible] = useState(false);// canceIconVisible
    const [timeDiscount, setTimeDiscount] = useState(false);// canceIconVisible
    const data = [];
    let nowDate = new Date();
    let year = nowDate.getFullYear();
    let month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1)
      : nowDate.getMonth() + 1;
    let day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate
      .getDate();
    let dateStr = year + "-" + month + "-" + day;
    useEffect(() => {
        restaurantStore.getSelectTimeAndDiscountData().then(function (data1) {
            if (null != data1) {
                let tempData = data1.data;
                if (undefined != tempData && null != tempData) {
                    for (let i = 0; i < tempData.length; i++) {
                        let todayData = tempData[i];
                        //dateStr
                        if (dateStr == todayData.date) {
                            let times = todayData.times;
                            for (let j = 0; j < times.length; j++) {
                                let time = times[j]
                                if (time.discount) {
                                    data.push({
                                        label:
                                          (<div>
                                              <span style={{...leftStyle}}>{t("RESERVATION_TIME")}:{time.time}</span>
                                              <span style={{...rightStyle}}>-{time.discount}</span>
                                          </div>),
                                        value: j + "-" + time.discount+"-"+time.time,
                                    })
                                }
                            }
                        }
                    }
                }
                if(data.length>0){
                    setSaveNormalIconVisible(true);
                }
            }
            setSelectTimeAndDiscountData(data)
        });//Select time & discount
        restaurantStore.getAllMenus().then(function (data) {
            let temp = [];
            let openKeys = []
            for (let key in data) {
                let menu = data[key];
                openKeys.push(key)
                temp.push({
                    "key": key,
                    "value": menu
                })
            }
            menus = temp;
            setAllmenus(menus);
        });//All
    }, []);
    const leftStyle = {
        width: '16px',
        height: '34px',
        marginLeft: '10px',
        float: 'left'
    };
    const rightStyle = {
        width: '16px',
        height: '34px',
        marginRight: '30px',
        float: 'right'
    };
    const [state1, setState1] = useState({
        selectValue: [''],
    });
    const onChangeSelect = (selectValue) => {
        let discount = selectValue[0].split("-")[1].substring(0, selectValue[0].split("-")[1].length - 1)
        setState1({
            selectValue: selectValue,
        });
        setTimeDiscount(selectValue[0].split("-")[2]+" - "+discount+"%")
        restaurantStore.getAllMenusCache(discount).then(function (data) {
            let temp = [];
            let openKeys = []
            for (let key in data) {
                let menu = data[key];
                openKeys.push(key)
                temp.push({
                    "key": key,
                    "value": menu
                })
            }
            menus = temp;
            setAllmenus(menus)
        });
        //set icon status
        setSaveNormalIconVisible(false)
        setSaveIconVisible(true)
        setCancelIconVisible(true)

    };
    function onCancel() {
        restaurantStore.getAllMenus().then(function (data) {
            let temp = [];
            let openKeys = []
            for (let key in data) {
                let menu = data[key];
                openKeys.push(key)
                temp.push({
                    "key": key,
                    "value": menu
                })
            }
            menus = temp;
            setAllmenus(menus)
        });//All
        setSaveNormalIconVisible(true)
        setSaveIconVisible(false)
        setCancelIconVisible(false)
        return;
    }
    const {t} = useTranslation();

    function handleClick(e) {
        setState({
            current: e.key,
            openKeys: e.keyPath.slice(1)
        });
    };
    return (
        <section className="page-restaurant--ALL">
            <h3>{t("WEB.Full menu")} <span className="title-nums">{menus.length}</span></h3>
            <Picker
              data={selectTimeAndDiscountData}
              value={state1.colorValue}
              cols={1}
              onChange={onChangeSelect}
              okText={t("CONFIRM")}
              dismissText={t("CANCEL")}
              title={t("WEB.Select time & discount")}>
                <div className="iconAllDiv">
                    <div style={{display: saveNormalIconVisible ? "inline-block" : "none"}}>
                        <Icon icon={"icon icon-book_and_save_normal_colored"}/>
                    </div>
                </div>
            </Picker>
            <div className="iconAllDiv">
                <div style={{display: canceIconVisible ? "inline-block" : "none",marginTop:"-5px"}}>
                    {t("RESERVATION_INFO.DISCOUNT")}{":"}{timeDiscount}
                </div>
                <div style={{display: saveIconVisible ? "inline-block" : "none"}}>
                    <Icon icon={"icon icon-save"}/>
                </div>
                <div style={{display: canceIconVisible ? "inline-block" : "none"}}  id={"cancel"} >
                    <Icon icon={"icon icon-cancel"} onClick={onCancel}/>
                </div>
            </div>
           <section>
               <Menu onClick={handleClick}
                     defaultOpenKeys={[state.current]}
                     selectedKeys={[state.current]}
                         mode="inline" >
                   {allmenus?allmenus.map((item) => {
                       return <Menu.SubMenu key={item.key} title={<span className="deal-title-all">{item.key}</span>}>
                           <div className="deals-list-ss ">
                               {item.value.map((item1, index1) => {
                                   return <MenuItem menu={item1} key={item1.id+item.key} odd={index1 % 2 === 0} mode={"all"}/>;
                               })}
                           </div>
                       </Menu.SubMenu>;
                   }):null}
               </Menu>
           </section>
        </section>
    );
};
export default All;
